// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"d9f9b533","99":"847b9709","134":"6c2b634a","211":"8e15b109","279":"5b002892","332":"4e7ef6bc","459":"6a3c7f38","503":"d20778e0","721":"7bf04efd","734":"a5f11298","787":"ce206071","906":"721535a9","940":"414ab669"}[chunkId] + ".chunk.js";
};